import { render, staticRenderFns } from "./PromotionGoods.vue?vue&type=template&id=d84ec850&scoped=true"
import script from "./PromotionGoods.vue?vue&type=script&lang=js"
export * from "./PromotionGoods.vue?vue&type=script&lang=js"
import style0 from "./PromotionGoods.vue?vue&type=style&index=0&id=d84ec850&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84ec850",
  null
  
)

export default component.exports